import React from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import UnderDevelopmentPage from '../../UnderDevelopmentPage'

const ProjectInsights = () => {
  return (
    <DashboardLayout>
      <UnderDevelopmentPage />
    </DashboardLayout>
  )
}

export default ProjectInsights
